import axios from 'axios';

export const poll_results = {
  methods: {
    poll_results: function(messageChanger) {
      const self = this;
      let elapsedTime = 0;
      const DELAY_TIME = 8000;
      let poller = setInterval(function() {
        elapsedTime += DELAY_TIME;

        if (self.maxWaitTime > 0 && elapsedTime >= self.maxWaitTime * 1000) {
          clearInterval(poller);
          self.sso(poller);
          return;
        }
        axios.get(
          `${self.remote_server}${process.env.POLL_URL}?id=${encodeURIComponent(self.response.requestId)}&workflow=${self.formdata.workflow}`, { timeout: 8000 }
        )
        .then(response => {
          switch(response.data.status) {
            case 'success':
            case 'partial':
            case 'Success':
            case 'Minor Failure':
            case 'Unexpected Status':
            case 'Completed Non-Deferred Actions':
              clearInterval(poller);
              self.sso(poller);
              break;
            case 'failed':
            case 'Major Failure':
              clearInterval(poller);
              self.hasError('Catch', {"message": response.data.message}, 'poller', messageChanger);
            default:
              break;
          }
        })
        .catch(e => {
          console.log(e); // Instead of throwing the error message just just log it and keep going
          //self.hasError('Catch', e, messageChanger);
        })
      }, DELAY_TIME); // 8 second interval
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/exports/methods/pollResults.js